import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { bodyToUnit, unitLabel } from '../strength/units';
import { useWeightUnit } from '../../hooks/useWeightUnit';

const API = process.env.REACT_APP_BACKEND_URL;

export const ProgressLightbox = ({
  isOpen,
  pictures,
  currentIndex,
  onClose,
  onNext,
  onPrev
}) => {
  const { unit } = useWeightUnit();
  if (!isOpen || pictures.length === 0) return null;

  const currentPicture = pictures[currentIndex];

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
        onClick={onClose}
        data-testid="lightbox-modal"
      >
        <button
          onClick={onClose}
          className="absolute top-6 right-6 h-12 w-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          <X className="h-6 w-6 text-white" />
        </button>

        {pictures.length > 1 && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onPrev();
              }}
              className="absolute left-6 h-12 w-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
            >
              <ChevronLeft className="h-6 w-6 text-white" />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onNext();
              }}
              className="absolute right-6 h-12 w-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
            >
              <ChevronRight className="h-6 w-6 text-white" />
            </button>
          </>
        )}

        <div 
          className="max-w-4xl max-h-[80vh] relative"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={`${API}${currentPicture.image_url}`}
            alt={currentPicture.caption || 'Progress photo'}
            className="max-w-full max-h-[70vh] object-contain"
          />
          <div className="mt-4 text-center">
            {currentPicture.caption && (
              <p className="text-white text-lg font-heading uppercase tracking-wider">
                {currentPicture.caption}
              </p>
            )}
            <div className="flex items-center justify-center gap-4 mt-2">
              <p className="text-muted-foreground">
                {new Date(currentPicture.created_at).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </p>
              {currentPicture.weight_at_time && (
                <p className="text-primary font-heading">
                  {bodyToUnit(currentPicture.weight_at_time, unit)} {unitLabel(unit)}
                </p>
              )}
            </div>
            <p className="text-muted-foreground text-sm mt-2">
              {currentIndex + 1} / {pictures.length}
            </p>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
